import { pdfjs } from 'react-pdf';

/**
 * Points pdf.js at its worker, once, wherever a PDF is drawn.
 *
 * The assignment is global and idempotent, but it has to have happened before the first render,
 * so each screen that draws a document calls this at module scope rather than trusting another
 * screen to have been loaded first.
 */
export const configurePdfWorker = (): void => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
};
